// "use client"

// import { getRouteApi, Link } from "@tanstack/react-router"
// import { buttonVariants } from "@workspace/web-ui/components/button"
// import { cn } from "@workspace/web-ui/lib/utils"
// import type { FormattedEncounter } from "~/features/dashboard/pages/encounters/types"
// import { UrgentCareTaskButtons } from "../tasks/urgent-care-task"

// // type MedicationItem = {
// //   category: string;
// //   medication: string;
// //   quantity: string;
// //   instructions: string[];
// //   is_extra?: boolean;
// //   is_primary?: boolean;
// //   is_secondary?: boolean;
// // };

// // function formatMedication(med: MedicationItem | string | null | undefined): string {
// //   if (!med) return "";

// //   // Handle string type
// //   if (typeof med === "string") return med;

// //   // Handle object with `medication` + optional `quantity`
// //   if ("medication" in med && med.medication) {
// //     return med.quantity ? `${med.medication} (${med.quantity})` : med.medication;
// //   }

// //   // Handle object with `name` + optional `dosage` (in case API changes)
// //   if ("name" in med && (med as any).name) {
// //     const m = med as { name: string; dosage?: string };
// //     return m.dosage ? `${m.name} (${m.dosage})` : m.name;
// //   }

// //   // Fallback
// //   try {
// //     return JSON.stringify(med);
// //   } catch {
// //     return String(med);
// //   }
// // }

// interface PatientSummaryProps {
//   encounter: FormattedEncounter
//   onOpenChange?: (open: boolean) => void
// }

// export const PatientSummary = ({ encounter }: PatientSummaryProps) => {
//   const routeApi = getRouteApi("/(dashboard)/dashboard/$program")
//   const { program } = routeApi.useParams()
//   console.log("encounter", encounter.session)

//   return (
//     <div className="space-y-4 w-full">
//       <div className="flex flex-col gap-3 w-full text-left rounded-[16px] border border-[#0404041A] pb-3 px-4 pt-4">
//         <h1 className="rounded-none data-[state=active]:bg-transparent font-medium data-[state=active]:border-b data-[state=active]:border-b-[#4A85FF]">
//           Patient Summary
//         </h1>
//         <div className="grid grid-cols-[min-content_1fr] text-sm gap-8">
//           <div className="flex flex-col gap-3">
//             {encounter?.patient.name && <p>Name</p>}
//             {encounter?.patient.gender && <p>Gender</p>}
//             {encounter?.patient.age && <p>Age</p>}
//             {encounter?.patient.email && <p>Email</p>}
//           </div>
//           <div className="flex flex-col gap-3 font-medium">
//             {encounter?.patient.name && <p>{encounter?.patient.name}</p>}
//             {encounter?.patient.gender && <p>{encounter?.patient.gender}</p>}
//             {encounter?.patient.age && <p>{encounter?.patient.age}yrs</p>}
//             {encounter?.patient.email && (
//               <p className="truncate max-w-[180px] sm:max-w-none" title={encounter.patient.email}>
//                 {encounter.patient.email}
//               </p>
//             )}
//           </div>
//         </div>
//       </div>

//       <UrgentCareTaskButtons encounter={encounter} />



//       {program === "urgent-care" && (
//         <div className="w-full flex flex-col gap-4 bg-[#EBF0FB] p-4 rounded-[8px] mt-3">
//           <div className="flex flex-col space-y-1 flex-1">
//             <p className="text-[#1A202C] font-semibold">Reported Symptoms</p>
//             <p className="text-[#464B55] text-[14px]">
//               {encounter?.session?.reported_symptoms || "No reported symptoms"}
//             </p>
//           </div>

//           <hr />

//           <div className="flex flex-col space-y-1 flex-1">
//             <p className="text-[#1A202C] font-semibold">Alfie's Diagnosis</p>
//             <p className="text-[#464B55] text-[14px]">
//               {encounter?.session?.diagnosis?.[0]?.disease_name && encounter?.session?.diagnosis?.[0]?.overview
//                 ? `${encounter.session.diagnosis[0].disease_name} - ${encounter.session.diagnosis[0].overview}`
//                 : "No diagnosis available"}
//             </p>
//           </div>

//           <hr />

//           <div className="flex flex-col space-y-1 flex-1">
//             <p className="text-[#1A202C] font-semibold">Alfie's Recommended treatment</p>
//             <p className="text-[#464B55] text-[14px]">
//               {encounter.session?.diagnosis?.[0]?.treatment_page?.medications?.[0]?.medication ||
//                 "No medication assigned"}
//             </p>

//             <ul className="text-[#464B55] text-[14px]">
//               {(
//                 encounter?.session?.diagnosis?.[0]?.treatment_page?.medications?.[0]?.instructions ||
//                 encounter?.session?.diagnosis?.[0]?.treatment_page?.medications?.[0]?.instructions ||
//                 []
//               ).map((instruction: string, index: number) => (
//                 <li key={index}>{instruction}</li>
//               ))}
//             </ul>
//           </div>

//           <Link
//             className={cn(
//               buttonVariants({ variant: "outline" }),
//               "w-full h-[44px] text-white rounded-[10px] bg-[#4272DD] py-3 px-4 hover:bg-[#4272DD] hover:text-white",
//             )}
//             to="/dashboard/$program/patients/patient/$id"
//             params={{
//               program,
//               id: encounter.patient.id,
//             }}
//             search={{
//               name: encounter.patient.name.replace(/\s+/g, ""),
//             }}
//           >
//             Review Patient Log
//           </Link>

//           <div className="flex flex-col gap-3 w-full text-left rounded-[16px] border border-[#0404041A] pb-4 px-4 pt-4">
//             <h2 className="font-medium text-[#1A202C]">Assigned actions</h2>
//             <div className="bg-[#F7F8FA] rounded-[8px] py-12 px-6 flex flex-col items-center justify-center text-center">
//               <p className="font-medium text-[#1A202C] mb-1">No assigned actions</p>
//               <p className="text-[#6B7280] text-[12px]">You haven't assigned any actions on this session yet</p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }












import { getRouteApi, Link } from "@tanstack/react-router"
import { Button, buttonVariants } from "@workspace/web-ui/components/button"
import { cn } from "@workspace/web-ui/lib/utils"
import type { FormattedEncounter } from "~/features/dashboard/pages/encounters/types"
import { UrgentCareTaskButtons } from "../tasks/urgent-care-task"
import { Circle, Trash2, Check, Loader2 } from "lucide-react"
import { useDeleteTaskMutation } from "../../api/tasks/mutation"
import { useState, useEffect } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { encountersKeys } from "../../pages/encounters/api/queries"
import { getApiProgram } from "~/lib/utils"
import { AppointmentStatusCard } from "../../pages/quick-actions/components/cards/appointment-status"
import { toast } from "sonner"
import { useUpdateAppointmentMutation } from "../../pages/quick-actions/api/mutations/appointment"
import { quickActionsKeys } from "../../pages/quick-actions/api/queries"
import { useSendActionNeededMutation } from "../../pages/patient-logs/api/mutations"
import { NotesContainer } from "../notes"


interface PatientSummaryProps {
  encounter: FormattedEncounter
  onOpenChange?: (open: boolean) => void
  showTask?: boolean
  type?: string
  onStatusChange?: (status: string, tag: string) => void
}

export const PatientSummary = ({ encounter, showTask, onOpenChange, type, onStatusChange }: PatientSummaryProps) => {
  const routeApi = getRouteApi("/(dashboard)/dashboard/$program")
  const { program } = routeApi.useParams()
  const queryClient = useQueryClient()
  const [taskId, setTaskId] = useState<string | null>(null)
  const [localStatus, setLocalStatus] = useState(encounter.status);
  const [localTag, setLocalTag] = useState(encounter.tag);
  const { mutate: sendActionNeeded, isPending: sendActionpending } = useSendActionNeededMutation();

  useEffect(() => {
    setLocalStatus(encounter.status);
    setLocalTag(encounter.tag);
  }, [encounter.status, encounter.tag]);

  // Check if meeting has passed by combining date and time
  // const hasMeetingPassed = (() => {
  //   try {
  //     // Assuming date format is like "Dec 24, 2024" and time is like "2:30 PM"
  //     const meetingDateTime = new Date(`${encounter.date} ${encounter.time}`);
  //     const now = new Date();
  //     return meetingDateTime < now;
  //   } catch (error) {
  //     // If date parsing fails, don't hide the section
  //     console.warn("Failed to parse meeting date/time:", { date: encounter.date, time: encounter.time }, error);
  //     return false;
  //   }
  // })();

  const encounterId = (encounter as any)?.id ?? (encounter as any)?.session?.id
  // patient id
  const patientId =
    (encounter as any)?.patient?.id ??
    (encounter as any)?.patient?.user_id


  // tasks: camelCase/snake_case safe
  const tasks =
    (encounter as any)?.recommendedTasks ??
    (encounter as any)?.recommended_tasks ??
    []


  const deleteTaskMutation = useDeleteTaskMutation({
    task_id: taskId ?? "",
    encounter_id: encounterId,
  });

  const UpdateAppointmentMutation = useUpdateAppointmentMutation({
    id: encounter?.id ?? "",
  });

  const handleDeleteTask = (id: string) => {
    setTaskId(id);
    deleteTaskMutation.mutate();
    queryClient.invalidateQueries({ queryKey: encountersKeys.encounters({ program: getApiProgram(program) }) });
  };

  const hasAssignedActions = Array.isArray(tasks) && tasks.length > 0


  // diagnosis meds (separate from tasks)
  const diagnosisMeds =
    (encounter as any)?.session?.diagnosis?.[0]?.treatment_page?.medications ?? []


  // reported symptom (snake vs camel safety)
  const reportedSymptom =
    (encounter as any)?.session?.reported_symptom ??
    (encounter as any)?.session?.reported_symptoms ??
    null


  // encounter status (what you asked to target)
  // const encounterStatus: string | undefined = (encounter as any)?.status
  // const isTaskCompleted = encounter.recommendedTasks.status === "completed"


  const isTaskCompleted = tasks?.status === "completed" || tasks?.erx_status === "fulfilled";

  const humanize = (s?: string) =>
    s ? s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "Task"

  const formatDate = (d?: string | number) => {
    if (!d) return "-"
    const dt = new Date(d)
    if (isNaN(dt.getTime())) return "-"
    return dt.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
  }

  const getTaskTitle = (task: any) => {
    if (task?.type === "medication_payment") return "Prescribed Medication"
    if (task?.type === "appointment_followup") return "Pay for Appointment"
    return humanize(task?.type)
  }

  const handleReviewPatientLog = () => {
    // Close the modal when the link is clicked
    onOpenChange?.(false)
  }

  const handleMarkAppointmentStatus = async (status: 'attended' | 'cancelled') => {
    const meetingStatus = status === "cancelled" ? "not-held" : "held";
    
    // Optimistic update - update UI immediately
    const previousStatus = localStatus;
    const previousTag = localTag;
    const newTag = status === "attended" ? "Held" : "Not Held";
    setLocalStatus(status);
    setLocalTag(newTag);
    
    // Notify parent component of status change for urgent care
    if (onStatusChange) {
      onStatusChange(status, newTag);
    }
    
    try {
      await UpdateAppointmentMutation.mutateAsync({
        status,
      }, {
        onSuccess(data) {
          if (data.status === "success") {
            toast.success(`Appointment marked as ${meetingStatus}`, {
              style: {
                background: "#6EE7B7",
                color: "#FFFFFF",
                borderColor: "#6EE7B7",
                "& svg": {
                  color: "#FFFFFF",
                },
              } as React.CSSProperties,
            });
          } else {
            // Rollback if API response indicates failure
            setLocalStatus(previousStatus);
            setLocalTag(previousTag);
            if (onStatusChange) {
              onStatusChange(previousStatus, previousTag);
            }
            toast.error(`Failed to update appointment status`);
          }
          queryClient.invalidateQueries({ queryKey: [quickActionsKeys.appointmentById(encounter.id ?? ""), encountersKeys.all] })
        },
        onError() {
          // Rollback on error
          setLocalStatus(previousStatus);
          setLocalTag(previousTag);
          if (onStatusChange) {
            onStatusChange(previousStatus, previousTag);
          }
          toast.error(`An error occurred while updating appointment status as ${meetingStatus}`);
        },
      });
    } catch (error) {
      // Rollback on exception
      setLocalStatus(previousStatus);
      setLocalTag(previousTag);
      if (onStatusChange) {
        onStatusChange(previousStatus, previousTag);
      }
    }
  };

  // Check if patient is verified for urgent care
  const urgentCareOnboarded = encounter?.patient?.urgent_care_onboarded ?? false;
  const identityVerified = encounter?.patient?.identity_verified ?? false;

  return (
    <div className="space-y-4 w-full">
      <div className="flex flex-col gap-3 w-full text-left rounded-[16px] border border-[#0404041A] pb-3 px-4 pt-4">
        <h1 className="rounded-none data-[state=active]:bg-transparent font-medium data-[state=active]:border-b data-[state=active]:border-b-[#4A85FF]">
          Patient Summary
        </h1>
        <div className="grid grid-cols-[min-content_1fr] text-sm gap-8">
          <div className="flex flex-col gap-3">
            {(encounter as any)?.patient?.name && <p>Name</p>}
            {(encounter as any)?.patient?.gender && <p>Gender</p>}
            {(encounter as any)?.patient?.age && <p>Age</p>}
            {(encounter as any)?.patient?.email && <p>Email</p>}
          </div>
          <div className="flex flex-col gap-3 font-medium">
            {(encounter as any)?.patient?.name && <p>{(encounter as any).patient.name}</p>}
            {(encounter as any)?.patient?.gender && <p>{(encounter as any).patient.gender}</p>}
            {(encounter as any)?.patient?.age && <p>{(encounter as any).patient.age}yrs</p>}
            {(encounter as any)?.patient?.email && (
              <p
                className="truncate max-w-[180px] sm:max-w-none"
                title={(encounter as any).patient.email}
              >
                {(encounter as any).patient.email}
              </p>
            )}
          </div>
        </div>
      </div>

      {(!type || type !== "appointment" || (type === "appointment" && encounter.is_consultation === true)) && (
        urgentCareOnboarded && identityVerified ? (
          <UrgentCareTaskButtons encounter={encounter} />
        ) : (
          <div className="">
            {/* <h3 className="text-lg font-bold text-black mb-3">Recommend Actions</h3> */}
            <div className="flex items-center bg-[#F0F5FF] rounded-lg px-4 py-2 justify-between w-full">
              <p className="text-sm text-[#1A202C]">
                Patient must be verified
              </p>
              <Button
                className="button-primary !bg-[#4272DD] h-[44px] !text-white flex gap-2 items-center !shadow-none w-fit !border-none"
                onClick={async () => {
                  try {
                    if (encounter?.patient.id) {
                      await sendActionNeeded({ patient_id: encounter.patient.id });
                      toast.success("Reminder sent to patient to complete verification.");
                    }
                  } catch (error) {
                    toast.error("Failed to send reminder.");
                  }
                }}
                disabled={sendActionpending || !encounter?.patient.id}
              >
                {sendActionpending && (
                  <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                  </svg>
                )}
                Send a Reminder
              </Button>
            </div>
          </div>
        )
      )}

      {/* {type === "appointment" && !hasMeetingPassed && (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 p-4 w-full bg-[#EBF0FB] rounded-lg">
          <div className="flex items-end w-full sm:w-fit">
            <Info className="size-6 text-[#4272DD]" />
          </div>
          {encounter.status === "happening" ? (
            <p className="text-sm font-normal text-[#202020CC]">This Appointment is live.</p>
          ) : (
            <p className="text-sm font-normal text-[#202020CC] whitespace-normal">This appointment is scheduled for {`${encounter.date}`}. Please ensure you're available 5 minutes before the start time. </p>
          )}

          {encounter.status === "happening" && (<Link
            className={cn(buttonVariants({ variant: "outline" }), "bg-transparent w-[135px] text-[#4272DD] justify-self-end rounded-[8px] border-none py-3 px-4 hover:bg-[#4272DD] hover:text-white")}
            to="/dashboard/$program/patients/patient/$id"
            params={{
              id: encounter?.patient.id || "",
              program
            }}
            search={{
              name: encounter?.patient.name.replace(/\s+/g, "") || "",
              sessionId: encounter?.session?.session_id || ""
            }}
          >
            View Patient Log
          </Link>)}

          <a href={encounter?.meetingLink}
            target="_blank" rel="noopener noreferrer"
            className={cn(buttonVariants({ variant: "default" }), "bg-[#4272DD] rounded-lg sw-full sm:w-auto", encounter.status !== "happening" ? "pointer-events-none cursor-not-allowed opacity-60 no-underline" : "")}>
            Join meeting
          </a>
        </div>
      )} */}

      {program === "urgent-care" && type === "appointment" && (
        <div className="flex gap-4 w-full flex-wrap">
          {(localStatus === "past" || localStatus === "cancelled") && (
            <div className="flex flex-col w-full">
              <AppointmentStatusCard
                status={localStatus}
                encounter={encounter}
                onStatusChange={handleMarkAppointmentStatus}
              />
            </div>
          )}
        </div>
      )}

      {/* {program === "urgent-care" && (
        <div className="flex gap-4 w-full flex-wrap">
          {(localStatus === "past" || localStatus === "cancelled") && (
            <div className="flex flex-col w-full">
              <AppointmentStatusCard
                status={localStatus}
                encounter={encounter}
                onStatusChange={handleMarkAppointmentStatus}
              />
            </div>
          )}
        </div>
      )} */}

      {program === "urgent-care" && (() => {
        const diagnosis = (encounter as any)?.session?.diagnosis?.[0];
        const sessionData = (encounter as any)?.session;
        const diseaseName = diagnosis?.disease_name?.toLowerCase() || "";
        const isSTI = diseaseName.includes('chlamydia') ||
          diseaseName.includes('gonorrhea') ||
          diseaseName.includes('herpes') ||
          diseaseName.includes('trichomonas') ||
          diseaseName.includes('bacterial vaginosis') ||
          diseaseName.includes('yeast infection') ||
          diseaseName.includes('vulvovaginal candidiasis') ||
          diseaseName.includes('sti') ||
          diseaseName.includes('std') ||
          diseaseName.includes('urethritis') ||
          diseaseName.includes('sexually transmitted');

        const toEntries = (questions: unknown) => {
          if (!questions || typeof questions !== "object") return [];
          if (questions === null) return [];
          return Object.entries(questions as Record<string, string | null>);
        };

        const intakeQuestionEntries = toEntries(sessionData?.intake_questions);
        const redFlagQuestionEntries = toEntries(sessionData?.red_flag_questions);
        const finalQuestionEntries = toEntries(sessionData?.final_questions);

        const formatAnswer = (answer: unknown) => {
          if (typeof answer === "string") {
            return answer.trim().length > 0 ? answer : "No response provided";
          }

          if (answer === null || answer === undefined) {
            return "No response provided";
          }

          try {
            return String(answer);
          } catch {
            return "No response provided";
          }
        };

        const additionalQuestion = typeof diagnosis?.treatment_page?.final_question === "string"
          ? diagnosis.treatment_page.final_question
          : null;
        const imageUrls = Array.isArray(diagnosis?.image_urls)
          ? diagnosis.image_urls.filter((url: unknown): url is string => typeof url === "string" && url.length > 0)
          : [];

        const shouldShowStiExtras = isSTI && (additionalQuestion || imageUrls.length > 0);
        const shouldShowInsightsCard = intakeQuestionEntries.length > 0 || redFlagQuestionEntries.length > 0 || shouldShowStiExtras;

        if (!shouldShowInsightsCard) {
          return null;
        }

        return (
          <div className="w-full bg-[#FEF3C7] p-4 rounded-[8px] border border-[#FDE68A]">
            <div className="flex flex-col gap-3">
              {/* General Questions */}
              <div className="flex flex-col space-y-1">
                <p className="text-[#1A202C] font-semibold">General Questions</p>
                {intakeQuestionEntries.length > 0 ? (
                  <ul className="text-[#464B55] text-[14px] list-disc ml-4 space-y-1">
                    {intakeQuestionEntries.map(([question, answer], index) => (
                      <li key={`${question}-${index}`}>
                        <span className="font-medium text-[#1A202C]">{question}</span>
                        {": "}
                        <span>{formatAnswer(answer)}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-[#464B55] text-[14px]">No general questions available</p>
                )}
              </div>

              {/* Red flag Questions */}
              <div className="flex flex-col space-y-1">
                <p className="text-[#1A202C] font-semibold">Red flag Questions</p>
                {redFlagQuestionEntries.length > 0 ? (
                  <ul className="text-[#464B55] text-[14px] list-disc ml-4 space-y-1">
                    {redFlagQuestionEntries.map(([question, answer], index) => (
                      <li key={`${question}-${index}`}>
                        <span className="font-medium text-[#1A202C]">{question}</span>
                        {": "}
                        <span>{formatAnswer(answer)}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-[#464B55] text-[14px]">No red flag questions available</p>
                )}
              </div>

              {/* Additional information - only for STI */}
              {isSTI && (
                <>
                  <hr className="border-[#FDE68A]" />
                  <div className="flex flex-col space-y-1">
                    <p className="text-[#1A202C] font-semibold">Additional information</p>
                    {finalQuestionEntries.length > 0 ? (
                      <ul className="text-[#464B55] text-[14px] list-disc ml-4 space-y-1">
                        {finalQuestionEntries
                          // Filter out any question that starts with "Upload a picture (if applicable)" or includes that phrase.
                          .filter(([question]) =>
                            typeof question !== "string" ||
                            !question.trim().toLowerCase().startsWith("upload a picture (if applicable)")
                          )
                          // Also filter out any entries whose answer is an image url (since these are shown in attachment section)
                          .filter(([, answer]) =>
                            !(typeof answer === "string" &&
                              answer.startsWith("http") &&
                              answer.includes("proxymd-medicals.s3.amazonaws.com"))
                          )
                          .map(([question, answer], index) => (
                            <li key={`${question}-${index}`}>
                              <span className="font-medium text-[#1A202C]">{question}</span>
                              {": "}
                              <span>{formatAnswer(answer)}</span>
                            </li>
                          ))}
                        {/* If nothing after filtering, show fallback */}
                        {finalQuestionEntries.filter(([question]) =>
                          typeof question !== "string" ||
                          !question.trim().toLowerCase().startsWith("upload a picture (if applicable)")
                        ).filter(([, answer]) =>
                          !(typeof answer === "string" &&
                            answer.startsWith("http") &&
                            answer.includes("proxymd-medicals.s3.amazonaws.com"))
                        ).length === 0 && (
                          <li className="list-none text-[#464B55] text-[14px]">No additional questions available</li>
                        )}
                      </ul>
                    ) : (
                      <p className="text-[#464B55] text-[14px]">No additional questions available</p>
                    )}
                  </div>
                </>
              )}

              {/* Image attachment - only for STI */}
              {isSTI && (
                <>
                  <hr className="border-[#FDE68A]" />
                  <div className="flex flex-col space-y-1">
                    <p className="text-[#1A202C] font-semibold">Image attachment</p>
                    {/* 
                      Check all final question entries for an answer string
                      that looks like an image URL, use the image directly!
                    */}
                    {(() => {
                      // Find any entry that contains a proxymd-medicals url
                      const attachmentEntry = finalQuestionEntries.find(
                        ([, answer]) =>
                          typeof answer === "string" &&
                          answer.startsWith("http") &&
                          answer.includes("proxymd-medicals.s3.amazonaws.com")
                      );
                      const urlFromFinalQuestions =
                        attachmentEntry && typeof attachmentEntry[1] === "string"
                          ? attachmentEntry[1]
                          : null;

                      // Prefer final-question image, else fallback to imageUrls
                      if (urlFromFinalQuestions) {
                        return (
                          <div className="flex flex-wrap gap-2 mt-2">
                            <a
                              href={urlFromFinalQuestions}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-[#4272DD] text-[14px] underline hover:text-[#2E5FCC]"
                            >
                              <img
                                src={urlFromFinalQuestions}
                                alt={`Attachment`}
                                className="max-w-[180px] max-h-[180px] rounded border"
                              />
                            </a>
                          </div>
                        );
                      }
                      return (
                        <p className="text-[#464B55] text-[14px]">No images attached</p>
                      );
                    })()}
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })()}

      {program === "urgent-care" && (
        <>
        <div className="w-full flex flex-col gap-4 bg-[#EBF0FB] p-4 rounded-[8px] mt-3">
          {/* Reported symptoms */}
          <div className="flex flex-col space-y-1 flex-1">
            <p className="text-[#1A202C] font-semibold">Reported Symptoms</p>
            <p className="text-[#464B55] text-[14px]">
              {reportedSymptom || "No reported symptoms"}
            </p>
          </div>

          <hr />

          {/* Diagnosis summary from session */}
          {type !== "appointment" && (
            <div className="flex flex-col space-y-1 flex-1">
              <p className="text-[#1A202C] font-semibold">Alfie's Diagnosis</p>
              <p className="text-[#464B55] text-[14px]">
                {(encounter as any)?.session?.diagnosis?.[0]?.disease_name &&
                  (encounter as any)?.session?.diagnosis?.[0]?.overview
                  ? (
                    <>
                      <span className="font-semibold">
                        {(encounter as any).session.diagnosis[0].disease_name}
                      </span>
                      {" - "}
                      {(encounter as any).session.diagnosis[0].overview}
                    </>
                  )
                  : "No diagnosis available"}
              </p>
            </div>
          )}

          {type !== "appointment" && <hr />}


          {/* Recommended treatment from diagnosis (NOT tasks) */}
          {type !== "appointment" && (
            <div className="flex flex-col space-y-3 flex-1">
              <p className="text-[#1A202C] font-semibold">Alfie's Recommended treatment</p>

              {Array.isArray(diagnosisMeds) && diagnosisMeds.length > 0 ? (
                <div className="space-y-4">
                  {diagnosisMeds.map((med: any, index: number) => (
                    <div key={index} className="rounded-md p-3">
                      <div className="space-y-2">
                        <div>
                          <p className="text-[#464B55] font-semibold text-[14px]">Medication</p>
                          <p className="text-[#464B55] text-[14px]">
                            {med?.medication ?? "No medication specified"}
                          </p>
                        </div>

                        <div>
                          <p className="text-[#464B55] font-semibold text-[14px]">Instructions</p>
                          {Array.isArray(med?.instructions) && med.instructions.length > 0 ? (
                            <ul className="text-[#464B55] text-[14px] list-disc ml-4 space-y-1">
                              {med.instructions.map((instruction: string, instrIndex: number) => (
                                <li key={instrIndex}>{instruction}</li>
                              ))}
                            </ul>
                          ) : (
                            <p className="text-[#464B55] text-[14px]">No instructions provided</p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="bg-white rounded-md p-3 border border-gray-200">
                  <p className="text-[#464B55] text-[14px]">No medication recommended</p>
                </div>
              )}
            </div>
          )}

          <Link
            className={cn(
              buttonVariants({ variant: "outline" }),
              "w-full h-[44px] text-[#4272DD] rounded-[10px] bg-[#F8FAFF] py-3 px-4 hover:bg-[#4272DD] hover:text-white border border-[#4272DD]"
            )}
            to="/dashboard/$program/patients/patient/$id"
            params={{
              program,
              id: patientId,
            }}
            search={{
              name: (encounter as any).patient.name.replace(/\s+/g, ""),
              sessionId: (type === "appointment" && !(encounter as any).is_consultation && (encounter as any)?.session?.session_id) ? (encounter as any).session.session_id : ""
            }}
            onClick={handleReviewPatientLog}
          >
            {type === "appointment" && !(encounter as any).is_consultation ? "Go to encounter session" : "Review Patient Log"}
          </Link>
        </div>

        {encounter.patient.urgent_care_onboarded && encounter.patient.identity_verified && (
                            <NotesContainer
                                encounterId={encounter.encounterId}
                                patientId={encounter.patient.id}
                                notes={encounter.notes}
                                icd={encounter.session?.icd10_code}
                            />
                        )
        }

        {showTask !== false && (
          <div className="flex flex-col gap-3 w-full text-left rounded-[16px] border border-[#0404041A] pb-4 px-4 pt-4">
            <h2 className="font-medium text-[#1A202C]">Assigned actions</h2>

            {hasAssignedActions ? (
              <div className="space-y-4">
                {tasks.map((task: any, index: number) => {
                  const isMedicationTask = task?.type === "medication_payment"
                  const meds = task?.prescription?.medication ?? []

                  return (
                    <div key={task?.task_id || index} className="bg-[#F7F8FA] rounded-[8px] p-4">
                      {/* Header row with icon + title (driven by ENCOUNTER status) */}
                      <div className="flex items-start justify-between mb-3">
                        <div className="flex items-center gap-3">

                          {isTaskCompleted ? (
                            <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
                              <Check className="w-3 h-3 text-white" />
                            </div>
                          ) : (
                            <Circle className="w-5 h-5 text-blue-500" />
                          )}
                          <div >
                            <h3
                              className={cn(
                                "font-medium",
                                isTaskCompleted ? "text-green-600" : "text-[#1A202C]"
                              )}
                            >
                              {getTaskTitle(task)}
                            </h3>


                            {/* <h3
                            className={cn(
                              "font-medium",
                              isEncounterCompleted ? "text-green-600" : "text-[#1A202C]"
                            )}
                          >
                            {isMedicationTask ? "Prescribed Medication" : humanize(task?.type)}
                          </h3> */}
                            {/* <h3
                            className={cn(
                              "font-medium",
                              isEncounterCompleted ? "text-green-600" : "text-[#1A202C]"
                            )}
                          >
                            {getTaskTitle(task)}
                          </h3> */}
                            <p className="text-sm text-[#6B7280]">
                              Assigned: {formatDate(task?.created_at)}
                            </p>
                          </div>
                        </div>
                        {/* {!isMedicationTask && (
                          <Trash2
                            className="w-5 h-5 text-[#6B7280] cursor-pointer hover:text-red-500"
                            onClick={() => {
                              if (task?.type === "appointment_followup") {
                                deleteTaskMutation.mutate()
                              }
                            }}
                          />
                        )} */}

                        {!isMedicationTask && (
                          <button
                            onClick={() => handleDeleteTask(task?.task_id)}
                            disabled={deleteTaskMutation.isPending}
                            className="p-1"
                          >
                            {deleteTaskMutation.status === "pending" ? (
                              <Loader2 className="w-5 h-5 animate-spin text-gray-400" />
                            ) : (
                              <Trash2 className="w-5 h-5 text-[#6B7280] cursor-pointer hover:text-red-500" />
                            )}
                          </button>
                        )}

                      </div>

                      {/* Medication details (each med in its OWN white card) */}
                      {isMedicationTask && Array.isArray(meds) && meds.length > 0 && (
                        <div className="space-y-3">
                          {meds.map((m: any, i: number) => (
                            <div
                              key={`${m?.name || "med"}-${i}`}
                              className="bg-white rounded-md p-2 space-y-2"
                            >
                              <h4 className="font-medium text-[#1A202C]">
                                {m?.name || "-"}
                              </h4>
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-[#6B7280]">
                                <div>
                                  <span className="font-medium">Dosage: </span>
                                  {m?.dosage ?? "-"}
                                </div>
                                <div>
                                  <span className="font-medium">Duration: </span>
                                  {typeof m?.duration === "number" ? `${m.duration} days` : (m?.duration ?? "-")}
                                </div>
                                <div className="md:col-span-2">
                                  <span className="font-medium">Instructions: </span>
                                  {Array.isArray(m?.instructions) ? (
                                    <ul className="list-disc ml-5">
                                      {m.instructions.map((ins: string, idx: number) => (
                                        <li key={idx}>{ins}</li>
                                      ))}
                                    </ul>
                                  ) : (
                                    <span>{m?.instructions ?? "-"}</span>
                                  )}
                                </div>
                                <div>
                                  <span className="font-medium">Refills: </span>
                                  {m?.refills ?? "-"}
                                </div>
                                <div>
                                  <span className="font-medium">Effective date: </span>
                                  {formatDate(m?.effective_date)}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Non-medication task details */}
                      {!isMedicationTask && (
                        <div className="text-sm text-[#6B7280] bg-white rounded-md p-2 space-y-2">
                          <div>
                            <span className="font-medium">Price: </span>
                            <span>{task?.cost ?? "-"}</span>
                          </div>
                          {task?.instructions && (
                            <div>
                              <span className="font-medium">Instructions: </span>
                              <span>{task.instructions}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className="bg-[#F7F8FA] rounded-[8px] py-12 px-6 flex flex-col items-center justify-center text-center">
                <p className="font-medium text-[#1A202C] mb-1">No assigned actions</p>
                <p className="text-[#6B7280] text-sm">You haven't assigned any actions on this session yet</p>
              </div>
            )}
          </div>

        )}
        </>
      )}
    </div>
  )
}